import { Component, OnInit } from '@angular/core';
import { NavigationWrapper } from '../../../core/routing/navigation-data';
import { pageMap } from '../../../core/routing/mapping/page-mapping';
import { ActivatedRoute } from '@angular/router';
import { PageKey } from '../../../core/routing/page-keys';
import { take } from 'rxjs/operators';
import { ProjectDataService } from './state-and-data-handling/project-data.service';
import { ShiveRoutes } from '../../../core/routing/segments/route-segments';

@Component({
  selector: 'app-project-detail',
  templateUrl: './project-detail.component.html',
  standalone: false,
})
export class ProjectDetailComponent implements OnInit {
  public tabs: NavigationWrapper[] = [];
  public title = '';

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly projectDataService: ProjectDataService,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.data.pipe().subscribe(({ data }) => {
      const project = data.project;
      this.projectDataService.addProject(project);
      this.title = project.name;
    });

    this.initTabs();
  }

  private initTabs(): void {
    this.activatedRoute.firstChild.params.pipe(take(1)).subscribe((params) => {
      const id = params.id;

      const navProgress = pageMap.get(PageKey.ProjectPageKeys.ProjectProgress);
      const navEdit = pageMap.get(PageKey.ProjectPageKeys.ProjectEdit);
      const navExpenses = pageMap.get(PageKey.ProjectPageKeys.ProjectExpenses);
      const navAttachments = pageMap.get(PageKey.ProjectPageKeys.ProjectAttachments);

      const progressNavItem: NavigationWrapper = {
        ...navProgress,
        route: navProgress.route.replace(ShiveRoutes.AnyId, id),
      };

      const editNavItem: NavigationWrapper = {
        ...navEdit,
        route: navEdit.route.replace(ShiveRoutes.AnyId, id),
      };

      const expensesNavItem: NavigationWrapper = {
        ...navExpenses,
        route: navExpenses.route.replace(ShiveRoutes.AnyId, id),
      };

      const attachmentsNavItem: NavigationWrapper = {
        ...navAttachments,
        route: navAttachments.route.replace(ShiveRoutes.AnyId, id),
      };

      this.tabs = [progressNavItem, editNavItem, expensesNavItem, attachmentsNavItem];
    });
  }
}
